import { ReactElement } from "react";
import { TeamMember } from "./teamMember";
import styles from "./team.module.scss";

export const Team = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleAndSupport}>
            <p className={styles.title}>{props.title}</p>
            <p className={styles.supportingText}>{props.supportingText}</p>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.memberGrid}>
          {props.members?.map((m, i) => <TeamMember key={i} {...m} />)}
        </div>
      </div>
    </section>
  );
};

interface Props {
  title: string;
  supportingText: string;
  members: {
    imageUrl: string;
    name: string;
    position: string;
    twitter?: string;
    linkedin?: string;
    github?: string;
  }[];
}
